import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService, CredentialsService } from '@app/core';
import { environment } from '@env/environment';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
export interface FeaturePayload {
  features: {
    featureKey: 'reservation' | 'menu' | 'opening_hours';
    enabled: boolean;
  }[];
}
@Injectable({
  providedIn: 'root'
})
export class WhatsappBotService {
  constructor(
    private http: HttpClient,
    private authService: AuthenticationService,
    private credentialsService: CredentialsService
  ) {}

  getWhatAppBotData() {
    const cred = this.credentialsService.credentials;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + cred.token
    });
    return this.http
      .get<any>(environment.whatAppBotUrl + `backoffice/clients/` + this.authService.activeClientId, {
        headers: headers
      })
      .pipe(
        map((resp: any) => {
          return resp;
        })
      );
  }

  toggleBotStatus(payload: any) {
    const cred = this.credentialsService.credentials;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
      // Authorization: 'Bearer ' + cred.token
    });
    return this.http
      .patch<any>(
        environment.whatAppBotUrl + `backoffice/clients/` + this.authService.activeClientId + '/bot-status',
        payload,
        {
          headers: headers
        }
      )
      .pipe(
        map((featureData: any) => {
          return featureData;
        })
      );
  }

  postFeatureData(payload: FeaturePayload) {
    const cred = this.credentialsService.credentials;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
      // Authorization: 'Bearer ' + cred.token
    });
    return this.http
      .patch<any>(
        environment.whatAppBotUrl + `backoffice/clients/` + this.authService.activeClientId + '/features',
        payload,
        {
          headers: headers
        }
      )
      .pipe(
        map((featureData: any) => {
          return featureData;
        })
      );
  }

  postInformationData(payload: any) {
    const cred = this.credentialsService.credentials;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
      // Authorization: 'Bearer ' + cred.token
    });
    return this.http
      .patch<any>(
        environment.whatAppBotUrl + `backoffice/clients/` + this.authService.activeClientId + '/information',
        payload,
        {
          headers: headers
        }
      )
      .pipe(
        map((featureData: any) => {
          return featureData;
        })
      );
  }

  sendWhatsAppSignupData(payload: {
    wabaId: string;
    phoneNumberId: string;
    businessPortfolioId: string;
    name: string;
  }) {
    const cred = this.credentialsService.credentials;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + cred.token
    });
    return this.http.patch<any>(
      environment.whatAppBotUrl + `backoffice/clients/` + this.authService.activeClientId + '/whatsapp-connection',
      payload,
      { headers }
    );
  }

  getTemplates(): Observable<any> {
    const cred = this.credentialsService.credentials;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + cred.token
    });
    return this.http.get<any>(
      environment.whatAppBotUrl + `backoffice/clients/` + this.authService.activeClientId + '/templates',
      { headers }
    );
  }

  updateTemplate(templateType: string, content: string): Observable<any> {
    const cred = this.credentialsService.credentials;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + cred.token
    });
    return this.http.patch<any>(
      environment.whatAppBotUrl +
        `backoffice/clients/` +
        this.authService.activeClientId +
        '/templates/' +
        templateType,
      { content },
      { headers }
    );
  }

  getFeatures(): Observable<any> {
    const cred = this.credentialsService.credentials;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + cred.token
    });
    return this.http.get<any>(environment.whatAppBotUrl + `backoffice/features`, { headers });
  }
}
